var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.modalId,
        "hide-header": "",
        "hide-footer": "",
        centered: "",
        size: _vm.size,
        "modal-class": "text-input-modal",
      },
      on: { hidden: _vm.onHidden, shown: _vm.focusInput },
    },
    [
      _c("div", { staticClass: "text-input-modal__shell" }, [
        _c("h2", { staticClass: "text-input-modal__title" }, [
          _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.draft,
              expression: "draft",
            },
          ],
          ref: "input",
          staticClass: "text-input-modal__input",
          attrs: {
            type: "text",
            placeholder: _vm.placeholder,
            maxlength: _vm.maxlength,
          },
          domProps: { value: _vm.draft },
          on: {
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              $event.preventDefault()
              return _vm.confirm.apply(null, arguments)
            },
            input: function ($event) {
              if ($event.target.composing) return
              _vm.draft = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "text-input-modal__actions" }, [
          _c(
            "button",
            {
              staticClass:
                "text-input-modal__btn text-input-modal__btn--cancel",
              attrs: { type: "button" },
              on: { click: _vm.close },
            },
            [_vm._v("\n        Cancel\n      ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "text-input-modal__btn text-input-modal__btn--ok",
              attrs: { type: "button", disabled: !_vm.draft.trim() },
              on: { click: _vm.confirm },
            },
            [_vm._v("\n        OK\n      ")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }